import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Button,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import SearchBar from "../../components/SearchBar";
import SwitchToggle from "../../components/SwitchToggle";
import AddIcon from "@mui/icons-material/Add";
import AddBlogCategory from "../../Modals/addBlogCategory";

const ManageBlogCategories = () => {
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState("");
  const [openModal, setOpenModal] = useState(false);

  const categories = [
    { id: 1, name: "Tips & Tricks for Buying Used Cars", createdDate: "01-Sept-2025", status: true },
    { id: 2, name: "Tips for Reducing Costs", createdDate: "02-Sept-2025", status: true },
    { id: 3, name: "Misconceptions and Legal Situation", createdDate: "03-Sept-2025", status: true },
    { id: 4, name: "Car, Truck, and Motorcycle Licenses", createdDate: "04-Sept-2025", status: false },
    { id: 5, name: "Commuter Allowance", createdDate: "05-Sept-2025", status: true },
    { id: 6, name: "Emission Standards", createdDate: "06-Sept-2025", status: true },
  ];

  return (
    <>
      {/* PAGE TITLE */}
      <div className="main_title">
        <h1>Blog Categories</h1>
        <p>
          <button onClick={() => navigate("/dashboard")}>Dashboard</button> –{" "}
          Blog Categories
        </p>
      </div>

      <div className="cards">
        {/* TABLE HEADER */}
        <div className="table_header">
          <div className="left_s">
            <SearchBar
              searchTerm={searchTerm}
              setDebouncedSearchTerm={setSearchTerm}
              placeholder="Search..."
            />
          </div>
          <div className="right_s">
            <Button
              className="btn btn_primary"
              onClick={() => setOpenModal(true)}
            >
              <AddIcon /> Add Blog Category
            </Button>
          </div>
        </div>

        {/* TABLE */}
        <TableContainer className="table_container">
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Sr. No</TableCell>
                <TableCell>Category</TableCell>
                <TableCell>Created Date</TableCell>
                <TableCell>Enable/Disable</TableCell>
                <TableCell>Actions</TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {categories.map((category, index) => (
                <TableRow hover key={category.id}>

                  {/* SR NO */}
                  <TableCell>{index + 1}</TableCell>

                  {/* CATEGORY */}
                  <TableCell>
                    <div className="user_block">
                      <p>
                        <b>{category.name}</b>
                      </p>
                    </div>
                  </TableCell>

                  {/* CREATED DATE */}
                  <TableCell>{category.createdDate}</TableCell>

                  {/* STATUS */}
                  <TableCell>
                    <SwitchToggle defaultChecked={category.status} />
                  </TableCell>

                  {/* ACTIONS */}
                  <TableCell>
                    <div className="table_actions v2">
                      <IconButton onClick={() => setOpenModal(true)}>
                        <img
                          src="/static/images/edit2_icon.svg"
                          alt="Edit"
                        />
                      </IconButton>
                      <IconButton>
                        <img
                          src="/static/images/trash2_icon.svg"
                          alt="Delete"
                        />
                      </IconButton>
                    </div>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </div>

      {/* ADD / EDIT MODAL */}
      <AddBlogCategory
        open={openModal}
        onClose={() => setOpenModal(false)}
        setOpen={setOpenModal}
      />
    </>
  );
};

export default ManageBlogCategories;
